import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import VideoPlayer from "./VideoPlayer";
import TextField from '@material-ui/core/TextField';
import axios from "axios";
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography';
import VideoInfo from "./VideoInfo"
// import sampleResponse from "./sampleResponse"
import sampleResultResponse from "./sampleResultResponse"
import CardContent from '@material-ui/core/CardContent'
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Tooltip from '@material-ui/core/Tooltip';
import FormGroup from '@material-ui/core/FormGroup'
import Button from '@material-ui/core/Button'
import PlayArrow from '@material-ui/icons/PlayArrow'
import FastForward from '@material-ui/icons/FastForward'
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled'
import PauseCircleFilled from '@material-ui/icons/PauseCircleFilled'
import OpenInNew from '@material-ui/icons/OpenInNew'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import green from '@material-ui/core/colors/green'
import CircularProgress from '@material-ui/core/CircularProgress'
import Input from '@material-ui/core/Input'
import Fab from '@material-ui/core/Fab';
import qs from "qs";
import NetworkInfo from "./NetworkInfo";
import ContentSearch from "./ContentSearch";


import ReactGA from 'react-ga';

import {urlConfig} from './config'

let videoJsOptions = {
    // width: 1008,
    // height: 567,
    autoplay: true,
    controls: true,
    sources: []
}

const styles = theme => ({
    divider: {
        height: theme.spacing.unit * 2,
    },
    container: {
        position: 'relative',
    },
});


class VideoAnalyzerContainer extends Component {

    constructor(props) {
        console.log("constructor");
        super(props);
        let parsed = qs.parse(this.props.location.search);

        if(parsed["?cid"] && parsed["?cid"].length>0){
            this.cid = parsed["?cid"];
        }else{
            this.cid = '1127009048';
        }

        if(parsed["t"] && parsed["t"].length>0){
            this.startTime = parsed["t"];
        }else{
            this.startTime = 0;
        }

        this.state = {
            suggestions: [],
            loadingVideo: false,
            selectedValue: 'AUTO',
            selectedQuality: 7,
            cid: 1127009048,
            videojsConfig: {},
            clipData: {},
            errorMessages: {},
            startTime: this.startTime,
        };


        this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
    }


    downloadSource = event => {
        window.location.href = this.state.clipData.entity.data.video.source.url;
    }
    handleChangeRadio = event => {
        this.setState({selectedFormat: event.target.value});
    }

    handleChangeQuality = event => {
        this.setState({selectedQuality: event.target.value}, () => {
            this.playLoadedVideo('VIU', 'DESKTOP', this.state.selectedQuality)
        });

    };

    handleChange = cid => event => {
        this.setState({
            [cid]: event.target.value,
        }, function () {

        });
    };

    handleChangeUrl = url => event => {
        this.setState({
            [url]: event.target.value,
        }, function () {

        });
    }

    handleChangeStartTime = startTime => event => {
        this.setState({
            [startTime]: event.target.value,
        }, function () {

        });
    }

    handleSuggestionSelect(event) {
        console.log(event);
        this.setState({cid:event}, ()  => {
            this.playVideo();
        })
    }

    tracksGenerator(response) {
        let subtitles = response.entity.data.asset.subtitles;

        let subtitleData = [];
        if (subtitles) {
            subtitles.forEach(function (subtitle) {

                if (subtitle.format == "vtt") {

                    let replacer = "https://premiumvideo-internal.vuclip.com";
                    let subtitleDataToPush = {
                        kind: 'captions',
                        file: subtitle.url.replace("https://gcpvuclip-a.akamaihd.net", replacer),
                        language: subtitle.language,
                        label: subtitle.language
                    };
                    subtitleData.push(subtitleDataToPush);
                }

            })
        }

        let chapterMarkers = {
            kind: 'chapters',
            file: 'ContentMarker.vtt',
        };

        subtitleData.push(chapterMarkers);

        return subtitleData;
    }

    sourcesGenerator(source, format, type, quality, response) {

        source = "https://storage.cloud.google.com/testwow/testVid2.mp4?_ga=2.254346888.-1861570390.1516216159";
        return [{file:source,type:'video/mp4'}];

        if (format === "VIU" || format === "CMS") {
            if (!quality) {
                quality = ""
            } else {
                quality = "_" + quality;
            }

            return [
                {
                    file: source.url, stereomode: true
                },
            ]
        } else if (format === "NP") {
            let sourcePlaylist = [];
            if(source && source.length>0){
                if(source.length===5){//p3 p1 p2 p4 p5
                    sourcePlaylist.push({file: source[4].url, type: type, stereomode: true, label:"P5 (480P)", default: true})
                    sourcePlaylist.push({file: source[3].url, type: type, stereomode: true, label:"P4 (360P)"})
                    sourcePlaylist.push({file: source[0].url, type: type, stereomode: true, label:"P3 (240P)"})
                    sourcePlaylist.push({file: source[2].url, type: type, stereomode: true, label:"P2 (180P)"})
                    sourcePlaylist.push({file: source[1].url, type: type, stereomode: true, label:"P1 (144P)"})
                }

                if(source.length===3){//p3 p1 p2
                    sourcePlaylist.push({file: source[0].url, type: type, stereomode: true, label:"P3 (240P)", default: true})
                    sourcePlaylist.push({file: source[2].url, type: type, stereomode: true, label:"P2 (180P)"})
                    sourcePlaylist.push({file: source[1].url, type: type, stereomode: true, label:"P1 (144P)"})
                }

            }
            console.log({sourcePlaylist})
            return {'sources':sourcePlaylist};
        } else if (format === "VP6") {
            return [
                {
                    drm: {clearkey: source.clearkey},
                    file: source.url, stereomode: true
                }
            ]
        } else if (format === "VP9") {
            return [
                {
                    drm: {clearkey: source.clearkey},
                    file: source.url, stereomode: true
                }
            ]
        }
        if (format === "SOURCE") {
            return [
                {file: source, type: type, stereomode: true},
            ]
        }


    }

    configureVideo(response, format, device, quality, updateState) {

        let vjsConfig = {};
        vjsConfig = videoJsOptions;

        let sources = [];

        if (response.entity.data) {


            if (format === "CMS" || format === "VIU") {
                if (device == 'DESKTOP') {
                    sources = this.sourcesGenerator(response.entity.data.video.trancodingDetails.HLS[0].files[0], format, 'application/x-mpegURL', quality, response)
                }
            }

            if (format === "VP6") {
                sources = this.sourcesGenerator(response.entity.data.video.trancodingDetails.DASH[0].files[0], format, 'application/dash+xml', quality, response)
            }
            if (format === "VP9") {
                sources = this.sourcesGenerator(response.entity.data.video.trancodingDetails.DASH[1].files[0], format, 'application/dash+xml', quality, response)
            }

            if (format === "NP") {
                sources = this.sourcesGenerator(response.entity.data.video.trancodingDetails.NP[0].files, format, 'video/mp4', quality, response)
            }

            if (format === "SOURCE") {
                sources = this.sourcesGenerator(response.entity.data.video.source.url, format, 'video/mp4', quality, response)
            }

            vjsConfig.sources = sources;

            vjsConfig.format = format;

            vjsConfig.cid = this.state.cid;

            if ((format === "VP6") || (format === "VP9") || (format === "VIU") || (format === "CMS")) {
                vjsConfig.startTime = parseInt(this.state.startTime)
                vjsConfig.sources[0].image = `https://i.vuclip.com/p?cid=${this.state.cid}&t=tjpeg800x450`;
            }
            if(format === "NP"){
                vjsConfig.sources.tracks = this.tracksGenerator(response);
            }
            if(format === "VIU"){
                vjsConfig.sources[0].file = vjsConfig.sources[0].file.replace(/hlsc_e2931.*.m3u8/, 'hlsc_e2931.m3u8')
                vjsConfig.sources[0].tracks = this.tracksGenerator(response);
            }

            ReactGA.ga('send','event',
                'videoplayer',
                format+"-VIDEO-PLAY",
                this.state.cid,
                1 );



            if (updateState) {
                this.setState({
                    clipData: response,
                    videojsConfig: vjsConfig
                }, () => {
                    this.forceUpdate();
                })
            } else {
                this.setState({
                    videojsConfig: vjsConfig
                }, () => {
                    this.forceUpdate();
                })
            }

        } else {
            vjsConfig.sources = [];

            this.setState({
                videojsConfig: vjsConfig
            }, () => {
                this.forceUpdate();
            })
        }




    }

    playLoadedVideo(format, device, quality) {
        let self = this;
        self.configureVideo(this.state.clipData, format, device, quality, false)
    }

    playVideo = function (event) {

        console.log('in play video');

        let serverUrl = urlConfig.bffUrl+'/video/';

        let self = this;

        if (true===true) {

            this.setState({loadingVideo: true})


            const caas2Instance = axios.create({
                baseURL: `${serverUrl}getClipData?cid=1127009048`,
                timeout: 120000,
                headers: {'ACCEPT': 'application/vnd.vuclip.cms.v2+json;charset=UTF-8'}
            });

            self.setState({
                errorMessages: {}
            });

            caas2Instance.get()
                .then(function (response) {
                    self.setState({clipData: {}})

                    if (response.data) {
                        if (response.data.status === "SUCCESS") {
                            if (response.data.entity) {

                                if (response.data.entity.data) {

                                    if (response.data.entity.data.video) {
                                        if (response.data.entity.data.video.trancodingDetails.HLS.length > 0) {
                                            self.setState({selectedQuality: 7});
                                            self.configureVideo(response.data, 'VIU', 'DESKTOP', 0, true);
                                            self.setState({selectedFormat: 'VIU', loadingVideo: false});
                                        } else {
                                            self.configureVideo(response.data, 'SOURCE', null, 0, true);
                                            self.setState({selectedFormat: 'SOURCE', loadingVideo: false})
                                        }
                                    } else {
                                        self.setState({
                                            clipData: response, loadingVideo: false
                                        });
                                    }

                                } else {
                                    self.setState({
                                        clipData: response, loadingVideo: false
                                    });
                                }
                            } else {
                                if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                    self.setState({
                                        clipData: {}, loadingVideo: false, errorMessages: response.data.genericMessages
                                    });
                                }
                            }
                        } else {
                            if(response.data.entity){
                                if (response.data.entity.data) {
                                    if (response.data.entity.data.video) {
                                        self.configureVideo(response.data, 'VIU', 'DESKTOP', 0, true);
                                        self.setState({
                                            clipData: response,
                                            loadingVideo: false,
                                            errorMessages: response.data.genericMessages
                                        });
                                    }
                                } else {
                                    self.setState({
                                        loadingVideo: false, errorMessages: response.data.genericMessages
                                    });
                                }
                            }else{
                                self.setState({
                                    loadingVideo: false,
                                    errorMessages: response.data.genericMessages
                                });
                            }
                        }
                    }
                    else {
                        self.setState({
                            clipData: {}, loadingVideo: false
                        });
                    }

                },function () {
                    self.setState({clipData: {}, loadingVideo: false})
                })
                .catch(function (error) {
                    self.setState({clipData: {}, loadingVideo: false})
                });
        } else {

        }


        const qapiInstance = axios.create({
            baseURL: `${serverUrl}getStatus?cid=${this.state.cid}`,
            timeout: 120000
        });


        qapiInstance.get().then(function (response) {
            if (response && response.data && response.data.entity){

                console.log("in qapi")
                console.log(response.data);
                self.setState({transcodingData: response.data.entity})
            }
        })


    }

    componentDidMount() {
        console.log("mounted");
        this.playVideo();
        // console.log(sampleResultResponse[0].results[0].annotationResults[0].explicitAnnotation.frames);
    }

    render() {
        const { classes, theme } = this.props;
        const flex = {flexGrow: 1};

        const containerStyle = {
            minHeight: '500px'
        }
        const formatCardStyle = {
            paddingBottom: '-10px'
        }

        const radioLabelStyle = {
            marginLeft: '-16px',
        }
        const radioStyle = {
            marginRight: '-12px'
        }
        const qualityLabelStyle = {
            marginTop: '10px'
        }

        const buttonProgress = {
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        };

        const progressButtonWrapper = {
            position: 'relative',
        };

        const inputStyle = {
            maxWidth: '7rem'
        }


        const normalPointStyle = {
            color:'#FAEBD7',
            fontSize:'20px',
            margin: '1px'
        }
        const explicitPointStyle = {
            color: '#EE82EE',
            fontSize:'20px',
            margin: '1px'
        }


        return (
            <div>

            <Grid container spacing={0}>


                <Grid item xs={12}>
                    <ContentSearch handleSuggestionSelect={this.handleSuggestionSelect} />
                </Grid>

                <Grid item xs={12}>
                    <Paper style={containerStyle}>

                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={10}>


                                {this.state && this.state.videojsConfig && this.state.videojsConfig.autoplay &&
                                <div>
                                    <VideoPlayer {...this.state.videojsConfig}/>
                                </div>
                                }

                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Paper>
                                    <CardContent>
                                        <form onSubmit={this.playVideo.bind(this)}>
                                            <FormGroup row>
                                                <Input style={inputStyle}
                                                       id="cid" autoFocus
                                                       label="CID" placeholder="Enter a CID"
                                                       value={this.state.cid}
                                                       onChange={this.handleChange('cid')}
                                                       required={true}
                                                />
                                                <span style={progressButtonWrapper}>

                                                    <Fab type="submit"
                                                         size="small"
                                                         color="primary"
                                                         onClick={this.playVideo.bind(this)}
                                                         disabled={this.state.loadingVideo}>
                                                        <PlayArrow/>
                                                    </Fab>

                                                    {this.state.loadingVideo &&
                                                    <CircularProgress size={24} style={buttonProgress}/>}
                                                </span>
                                            </FormGroup>
                                        </form>



                                        {this.state && this.state.clipData.entity &&
                                        <span>
                                                {this.state.clipData.entity.data.shortTitle.length > 25 &&
                                                <Tooltip title={this.state.clipData.entity.data.shortTitle}>
                                                    <Typography variant="h6"
                                                                style={{marginTop: '10px'}}>{this.state.clipData.entity.data.shortTitle.substr(0, 25)} ...</Typography>
                                                </Tooltip>}
                                            {this.state.clipData.entity.data.shortTitle.length <= 25 &&
                                            <Typography variant="h6"
                                                        style={{marginTop: '10px'}}>{this.state.clipData.entity.data.shortTitle} </Typography>}
                                            </span>
                                        }

                                    </CardContent>

                                    <Divider/>

                                    {this.state && this.state.cid &&
                                    <List component="nav" dense>

                                        {this.state.clipData.entity &&
                                        <span>
                                            {this.state && this.state.clipData.entity.data.video.trancodingDetails.HLS.length > 0 &&
                                            <ListItem divider>

                                                <FormControl>
                                                    <FormLabel component="legend">HLS</FormLabel>
                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                                          onClick={this.playLoadedVideo.bind(this, 'VIU', 'DESKTOP', 7)}
                                                                          checked={this.state.selectedFormat === 'VIU'}
                                                                          value="VIU"
                                                                          control={<Radio icon={<PlayCircleFilled/>}
                                                                                          checkedIcon={
                                                                                              <PauseCircleFilled/>}/>}
                                                                          label="Viu"/>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                                          onClick={this.playLoadedVideo.bind(this, 'CMS', 'DESKTOP', 7)}
                                                                          checked={this.state.selectedFormat === 'CMS'}
                                                                          value="CMS"
                                                                          control={<Radio icon={<PlayCircleFilled/>}
                                                                                          checkedIcon={
                                                                                              <PauseCircleFilled/>}/>}
                                                                          label="CMS"/>
                                                    </FormGroup>

                                                </FormControl>
                                            </ListItem>}

                                            {this.state && this.state.clipData.entity.data.video.trancodingDetails.DASH.length > 0 &&
                                            <ListItem divider>
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend">Viu App (Mpeg Dash)</FormLabel>
                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                                          disabled={false}
                                                                          onClick={this.playLoadedVideo.bind(this, 'VP6', null, 0)}
                                                                          checked={this.state.selectedFormat === 'VP6'}
                                                                          value="VP6"
                                                                          control={<Radio icon={<PlayCircleFilled/>}
                                                                                          checkedIcon={
                                                                                              <PauseCircleFilled/>}/>}
                                                                          label="VP6"/>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                                          disabled={false}
                                                                          onClick={this.playLoadedVideo.bind(this, 'VP9', null, 0)}
                                                                          checked={this.state.selectedFormat === 'VP9'}
                                                                          value="VP9"
                                                                          control={<Radio icon={<PlayCircleFilled/>}
                                                                                          checkedIcon={
                                                                                              <PauseCircleFilled/>}/>}
                                                                          label="VP9"/>
                                                    </FormGroup>

                                                </FormControl>
                                            </ListItem>}

                                            {this.state && this.state.clipData.entity.data.video.trancodingDetails.NP.length > 0 &&
                                            <ListItem divider>
                                                <FormControl>
                                                    <FormGroup row>
                                                        <FormControlLabel
                                                            onChange={this.handleChangeRadio}
                                                            onClick={this.playLoadedVideo.bind(this, 'NP', null, 2)}
                                                            checked={this.state.selectedFormat === 'P5'}
                                                            value="P5"
                                                            control={<Radio icon={<PlayCircleFilled/>}
                                                                            checkedIcon={
                                                                                <PauseCircleFilled/>}/>}
                                                            label="Mass Market"/>
                                                    </FormGroup>

                                                </FormControl></ListItem>}

                                            {this.state && this.state.clipData.entity.data.video.source &&
                                            <ListItem divider>
                                                <FormControl component="fieldset">

                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                                          onClick={this.playLoadedVideo.bind(this, 'SOURCE', null, 0)}
                                                                          checked={this.state.selectedFormat === 'SOURCE'}
                                                                          value="SOURCE"
                                                                          control={<Radio icon={<PlayCircleFilled/>}
                                                                                          checkedIcon={
                                                                                              <PauseCircleFilled/>}/>}
                                                                          label="Source"/>
                                                    </FormGroup>

                                                    {/[^.]*$/.exec(this.state.clipData.entity.data.video.source.url).toString().toLowerCase() !== 'mp4' &&
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        May not be playable.
                                                    </Typography>}

                                                </FormControl></ListItem>}

                                            <ListItem divider>
                                                <form onSubmit={this.playVideo.bind(this)}>
                                                <FormGroup row>
                                                <TextField style={inputStyle}
                                                           id="seek"
                                                           label="Jump Seconds" placeholder="Enter seconds"
                                                           value={this.state.startTime}
                                                           onChange={this.handleChangeStartTime('startTime')}
                                                           required={true}
                                                />
                                                <span style={progressButtonWrapper}>

                                                <Fab type="submit"
                                                     size="small"
                                                     onClick={this.playVideo.bind(this)}
                                                     disabled={this.state.loadingVideo}>
                                                <FastForward/>
                                                </Fab>

                                                    {this.state.loadingVideo &&
                                                    <CircularProgress size={24} style={buttonProgress}/>}
                                                </span>
                                                </FormGroup>
                                                </form>
                                            </ListItem>
                                            </span>}

                                        {this.state && this.state.cid && this.state.transcodingData &&
                                        <ListItem>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend">Transcoding Status</FormLabel>

                                                <br/>

                                                {this.state.transcodingData &&
                                                <FormLabel>
                                                    {this.state.transcodingData.transcodingStatus &&
                                                    <Typography variant="caption">
                                                        OTT : {this.state.transcodingData.transcodingStatus.status} &nbsp;
                                                        {this.state.transcodingData.transcodingStatus.transcodingPercentage &&
                                                        this.state.transcodingData.transcodingStatus.transcodingPercentage!=100 &&
                                                        <span>{this.state.transcodingData.transcodingPercentage}</span>}
                                                    </Typography>}

                                                    {!this.state.transcodingData &&
                                                    <Typography variant="caption" gutterBottom>OTT : Not
                                                        Transcoded</Typography>}

                                                    {this.state.transcodingData &&
                                                    <Typography variant="caption" gutterBottom>Platform : {this.state.transcodingData.transcodingPlatform}
                                                    </Typography>}

                                                </FormLabel>}
                                            </FormControl></ListItem>}
                                    </List>}
                                </Paper>
                            </Grid>
                        </Grid>
                        {this.state.errorMessages && this.state.errorMessages.ERROR && this.state.errorMessages.ERROR.length > 0 &&
                        <Grid container spacing={0}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={10}>
                                {this.state.errorMessages.ERROR.map(function (errorMessage, index) {
                                    return (<Typography variant='title' key={index} color='secondary'>
                                        Error : {errorMessage.message}
                                    </Typography>)
                                })}
                            </Grid>
                            <Grid item xs={1}></Grid>
                        </Grid>}

                        <Grid container>
                            {sampleResultResponse[0].results[0].annotationResults[0].explicitAnnotation.frames.map(function (frame) {
                                if(frame.pornographyLikelihood>3){
                                    return (<Tooltip title="Explicit"><span style={explicitPointStyle}>.</span></Tooltip>)
                                }else{
                                    return (<span style={normalPointStyle}>.</span>)
                                }
                            })}
                        </Grid>

                    </Paper>
                </Grid>


                <NetworkInfo/>
            </Grid>
            </div>

        );
    }
}


VideoAnalyzerContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, { withTheme: true })(VideoAnalyzerContainer);
